function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "currentColor",
  fillRule: "nonzero"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M18.746 34.52c.306-.408.86-.513 1.3-.232l.08.058c.392.32.485.89.209 1.36l-.042.06-2.131 2.847c-.322.43-.909.516-1.364.186l-.054-.045-1.41-1.276c-.404-.367-.448-1.004-.097-1.427.33-.396.89-.464 1.33-.148l.057.047.627.568zm21.358 1.488c.495 0 .896.4.896.896 0 .495-.401.896-.896.896H24.868c-.495 0-.896-.401-.896-.896s.401-.896.896-.896h15.236zm-22.708-9.12c1.167 0 2.113.963 2.113 2.15 0 1.188-.946 2.151-2.113 2.151-1.168 0-2.114-.963-2.114-2.15 0-1.188.946-2.15 2.114-2.15zm22.708.876c.495 0 .896.402.896.896 0 .495-.401.897-.896.897H24.868c-.495 0-.896-.402-.896-.897 0-.494.401-.896.896-.896h15.236zM17.501 18c.608 0 1.015.387 1.059.977l.004.106v3.519c0 .583-.397.99-.963.99-.533 0-.916-.361-.96-.89l-.003-.1v-2.475l-.072.053c-.109.08-.203.126-.31.148l-.082.013-.09.004c-.415 0-.732-.333-.732-.768 0-.265.1-.489.3-.661l.08-.062.842-.589c.29-.202.55-.265.927-.265zm22.603 1.521c.495 0 .896.401.896.896s-.401.896-.896.896H24.868c-.495 0-.896-.4-.896-.896 0-.495.401-.896.896-.896h15.236z",
  transform: "translate(-387 -4665) translate(0 4345) translate(340 130) translate(0 178) translate(47 12)"
})))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/list.1998bac6.svg";
export { SvgComponent as ReactComponent };